/**
 * auditTask模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const auditTask = {
  //审核任务列表分页
  pageAuditTask(params) {
    return $http.post(`${global.API_URL}/sme/auditTask/page`,params);
  },
  // 审批定时任务
  approvalAuditTask(params) {
    return $http.post(`${global.API_URL}/sme/auditTask/approvalAuditTask`,params);
  },
  // 删除定时任务
  createAuditTask(params) {
    return $http.post(`${global.API_URL}/sme/auditTask/create`,params);
  }
}

export default auditTask;



// WEBPACK FOOTER //
// ./src/api/auditTask.js